export var SUBSCRIPTION_STATUS;
(function (SUBSCRIPTION_STATUS) {
  SUBSCRIPTION_STATUS["ACTIVE"] = "active";
  SUBSCRIPTION_STATUS["SUSPENDED"] = "suspended";
  SUBSCRIPTION_STATUS["CANCELLED"] = "cancelled";
  SUBSCRIPTION_STATUS["PENDING"] = "pending";
})(SUBSCRIPTION_STATUS || (SUBSCRIPTION_STATUS = {}));